import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
    CCHttpTranslateLoader,
  CCNotificationsModule,
  CCTranslateModule,
  CC_TRANSLATE_MODULE_LOADER,
} from '@maids/cc-lib/services';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  CoreRouterSerializer,
  CCCoreModule,
  fromRouterState,
  CCPaginationModule,
} from '@maids/cc-lib/common';
import {
  CCAwaitThemeModule,
  CC_THEME_ASSETS_BASE_URL,
  provideThemeLoaders,
} from '@maids/cc-lib/theme';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { EffectsModule } from '@ngrx/effects';
import { CCBreadcrumbsModule, CCLayoutModule } from '@maids/cc-lib/layout';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import {
  CCAuthInterceptor,
  CCAuthService,
  CCBackendEndpoint,
  CCErpAuthModule,
  CCErpIntegrationModule,
  CCLoadingIconModule,
  CCPicklistModule,
  ErpRedirectionModule,
  LegacyNotificationService,
  MODULE_NAME,
} from '@maids/cc-erp-services';
import { CoreModule } from './modules/core/core.module';
import { NetworkErrorInterceptor } from './modules/core/interceptors/network-error.interceptor';
import { CCFileUploaderModule } from '@maids/cc-lib/file-uploader';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CCInputModule } from '@maids/cc-lib/input';
import { CCButtonModule } from '@maids/cc-lib/button';
import { CCCardModule } from '@maids/cc-lib/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CCSidenavModule } from '@maids/cc-lib/sidenav';
import { CCListModule } from '@maids/cc-lib/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { CCIconModule } from '@maids/cc-lib/icon';
import { MatIconModule } from '@angular/material/icon';
import { CCDividerModule } from '@maids/cc-lib/divider';
import { CCErpLayoutModule } from '@maids/cc-shared-components/erp-layout';
import { UaePassModule } from './modules/uae-pass/uae-pass.module';

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        CoreModule,
        UaePassModule,
        CommonModule,
        FormsModule,
        CCInputModule,
        CCButtonModule,
        CCCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        ReactiveFormsModule,
        CCSidenavModule,
        CCListModule,
        CCIconModule,
        MatDividerModule,
        MatCardModule,
        MatIconModule,
        CCBreadcrumbsModule,
        CCDividerModule,
        CCErpLayoutModule,
        CCTranslateModule.forRoot({
            defaultLanguage: 'en',
            loader: [
              {
                provide: CC_TRANSLATE_MODULE_LOADER,
                deps: [HttpClient],
                useFactory: (http: HttpClient) => {
                  return new CCHttpTranslateLoader(http, 'assets/i18n/', '.json');
                },
              },
            ],
          }),
        CCCoreModule.forRoot({
            backendEndpoint: { useValue: environment.apiBase },
        }),
        BrowserAnimationsModule,
        StoreRouterConnectingModule.forRoot({
            stateKey: fromRouterState.RouterFeatureKey,
            serializer: CoreRouterSerializer,
        }),
        EffectsModule.forRoot([]),
        CCErpAuthModule.forRoot(),
        ErpRedirectionModule.forRoot({
            replaceAuthGuard: environment.newErp,
        }),
        CCLayoutModule,
        CCAwaitThemeModule.forRoot({
            withAuth: CCAuthService,
            themeLoaders: provideThemeLoaders({
                'cc-default-light': () => import('@maids/cc-lib/prebuilt-themes/default-light.scss'),
                'cc-default-dark': () => import('@maids/cc-lib/prebuilt-themes/default-dark.scss'),
                'cc-amazon-light': () => import('@maids/cc-lib/prebuilt-themes/amazon-light.scss'),
                'cc-amazon-dark': () => import('@maids/cc-lib/prebuilt-themes/amazon-dark.scss'),
                'cc-sunrise-dark': () => import('@maids/cc-lib/prebuilt-themes/cc-sunrise-dark.scss'),
                'cc-sunrise-light': () => import('@maids/cc-lib/prebuilt-themes/cc-sunrise-light.scss'),
            }),
        }),
        CCPaginationModule.forRoot(),
        StoreModule.forRoot({ [fromRouterState.RouterFeatureKey]: fromRouterState.reducer }, {}),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: environment.production,
        }),
        CCErpIntegrationModule,
        CCNotificationsModule.forRoot({
            legacyNotificationService: LegacyNotificationService,
        }),
        CCLoadingIconModule.forRoot(),
        CCFileUploaderModule.forRoot(),
        CCPicklistModule.forRoot({ pageSize: 30 })], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            multi: true,
            useClass: NetworkErrorInterceptor,
        },
        { provide: HTTP_INTERCEPTORS, multi: true, useClass: CCAuthInterceptor },
        { provide: CC_THEME_ASSETS_BASE_URL, useValue: '.' },
        { provide: CCBackendEndpoint, useValue: environment.apiBase },
        { provide: MODULE_NAME, useValue: 'visa' },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
